import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {SectionHeading} from "../misc/Headings";
import { useTranslation } from "react-i18next";
const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto`; // Без отступов сверху



const HeadingColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;

const HeadingTitle = tw(SectionHeading)`w-full `;

const HeadingDescription = tw.p`my-5 lg:my-8 text-base xl:text-xl my-2 lg:my-4 text-gray-700`;

const Break = styled.div`
  ${tw`my-4`}
`;

export default () => {
    const { t } = useTranslation(); // вне компонента!

    return (
        <Container>
            <Content>
                <HeadingColumn>
                    <HeadingDescription>
                        {t("buyout.info")}
                        <Break />
                        {t("buyout.details")}
                    </HeadingDescription>
                </HeadingColumn>
            </Content>
        </Container>
    );
};
